import React from "react";
import PropTypes from "prop-types";
import { Row } from "antd";

const Loader = ({ type, extraClass }) => {
  const loader = <div className="loader">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>;

  switch (type) {
    case "page":
      return (
        <Row justify="space-around" align="middle" className={`page__loader ${extraClass}`}>{loader}</Row>
      );
    case "section":
      return (
        <Row justify="space-around" align="middle" className={`section__loader ${extraClass}`}>{loader}</Row>
      );
    default:
      return loader;
  }
};

Loader.propTypes = {
  type: PropTypes.string,
  extraClass: PropTypes.string
};

export default Loader;
